<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EafAvN/tc-custom/9781788636179.jpg?1718106103323" alt="This image is the cover for the book Throne of Isis, The Three Queens"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Throne of Isis, The Three Queens
      </h1>
      <p class="bookDescription body article font2">
        <p>  </p><p><b>Passion and politics clash in this epic saga retelling the love affair between Cleopatra, Egypt’s last queen, and Roman general Antony.</b></p><p> Cleopatra’s priestess cousin Dione, standing in the shadows, is witness to all Cleopatra’s romantic and military alliances. The queen is determined to maintain her hold on the throne of Egypt despite Rome’s persistent attacks. But what happens when a queen falls in love with the man she intended only to use for his political power? </p><p><b>This first book in the Three Queens series is perfect for fans of Michelle Moran and Wilbur Smith.</b></p><p><b>Praise for <i>Throne of Isis</i></b></p><b>“Cleopatra's prescient cousin, Dione, sparks the story with her exuberant personality and manages to present a unique perspective on background events.</b><b>She is joined in her pessimistic reading of signs and portents by Roman augur Lucius Servilius, an engaging figure whose stiff Roman pride crumbles before Dione’s charms, and the two visionaries embark on a sizzling romance.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judith Tarr
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19a46dd0